import React from "react";
import moment from 'moment';
import styled from "styled-components";

const PaidCircle = styled.div`
  height: 6px;
  width: 6px;
  background-color: ${({$allPaid}) => $allPaid ? '#3DC03C' : '#ef0c0c'};
  border-radius: 50%;
  margin-left: 5px;
`

export default ({
  compensationData,
  variant
}) => {
  const {
    endDate = '',
    email = '',
    totalCompensation = '',
    totalPerDiemCompensation = '',
    totalTrainingCompensation = '',
    reimbursementTotal = '',
    allPaid
  } = compensationData
  
  return (
    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      padding: '20px',
      border: '1px solid #dcdcdc',
      borderRadius: '10px',
      maxWidth: (variant === 'eventCompensation' ? '600px' : '300px')
    }}>
      <div style={{
        color: '#a5a5a5',
        fontSize: '14px',
        marginBottom: '5px'
      }}>
        {moment(endDate).format('MM/DD/YY')}
      </div>
      <div style={{
        color: '#565656',
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '20px'
      }}>
        {email}
      </div>
      <div style={{
        display: 'flex',
        columnGap: '20px'
      }}>
        <div>
          <div style={{
            color: '#a5a5a5',
            fontSize: '14px',
            marginBottom: '5px'
          }}>
            {'Total Compensation'}
          </div>
          <div style={{
            color: '#565656',
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '10px'
          }}>
            {totalCompensation || 0}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ color: '#a5a5a5', fontSize: '14px' }}>{'Paid'}</div>
            <PaidCircle $allPaid={allPaid} />
          </div>
        </div>
        <div>
          <div style={{
            color: '#a5a5a5',
            fontSize: '14px',
            marginBottom: '5px'
          }}>
            {'Amount Earned as Per Diem'}
          </div>
          <div style={{
            color: '#565656',
            fontSize: '18px',
            fontWeight: 'bold',
            marginBottom: '10px'
          }}>
            {totalPerDiemCompensation || 0}
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ color: '#a5a5a5', fontSize: '14px' }}>{'Paid'}</div>
            <PaidCircle $allPaid={allPaid} />
          </div>
        </div>
        {variant === 'eventCompensation' &&
          <>
            <div>
              <div style={{
                color: '#a5a5a5',
                fontSize: '14px',
                marginBottom: '5px'
              }}>
                {'Training Compensation'}
              </div>
              <div style={{
                color: '#565656',
                fontSize: '18px',
                fontWeight: 'bold',
                marginBottom: '10px'
              }}>
                {totalTrainingCompensation || 0}
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ color: '#a5a5a5', fontSize: '14px' }}>{'Paid'}</div>
                <PaidCircle $allPaid={allPaid} />
              </div>
            </div>
            <div>
              <div style={{
                color: '#a5a5a5',
                fontSize: '14px',
                marginBottom: '5px'
              }}>
                {'Reimbursement Total'}
              </div>
              <div style={{
                color: '#565656',
                fontSize: '18px',
                fontWeight: 'bold',
                marginBottom: '10px'
              }}>
                {reimbursementTotal || 0}
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ color: '#a5a5a5', fontSize: '14px' }}>{'Paid'}</div>
                <PaidCircle $allPaid={allPaid} />
              </div>
            </div>
          </>
        }
      </div>
    </div>
  )
}